import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../theme/theme.css";
import "../css/Navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("app-theme") || "light";
    document.documentElement.dataset.theme = savedTheme;
    setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    document.documentElement.dataset.theme = newTheme;
    localStorage.setItem("app-theme", newTheme);
    setTheme(newTheme);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* LEFT */}
        <Link to="/" className="navbar-logo">
          <img
            src="/Inquizene_logo.png"
            alt="Inquizene Logo"
            className="navbar-logo-image"
          />
          Inquizene
        </Link>

        {/* RIGHT */}
        <div className="navbar-right">
          <div className="navbar-links">
            <NavLink to="/" label="Home" />
            <NavLink to="/products" label="Products" />
            <NavLink to="/solutions" label="Solutions" />
            <NavLink to="/pricing" label="Pricing" />
            <NavLink to="/contact" label="Contact" />
          </div>

          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>

          <button
            className="navbar-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? "✕" : "☰"}
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="navbar-mobile">
          <NavLink mobile to="/" label="Home" onClick={() => setOpen(false)} />
          <NavLink mobile to="/products" label="Products" onClick={() => setOpen(false)} />
          <NavLink mobile to="/solutions" label="Solutions" onClick={() => setOpen(false)} />
          <NavLink mobile to="/pricing" label="Pricing" onClick={() => setOpen(false)} />
          <NavLink mobile to="/contact" label="Contact" onClick={() => setOpen(false)} />
          {/* <button className="theme-toggle mobile" onClick={toggleTheme}>
            {theme === "dark" ? "☀️ Light Mode" : "🌙 Dark Mode"}
          </button> */}
        </div>
      )}
    </nav>
  );
}

function NavLink({ to, label, mobile, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`nav-link ${mobile ? "mobile" : ""}`}
    >
      {label}
    </Link>
  );
}
